import {defineStore} from 'pinia'
import {useUserStore} from "@/stores/user";
import router from "@/router";

export const useDomainsStore = defineStore('domains_store', {
    state: () => ({
        items: [],
        loading: false,
        contactLoading: false,
    }),
    actions: {
        index(kdnr = null) {
            this.loading = true
            const resolvedKdnr = kdnr || useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr

            if (!resolvedKdnr) {
                this.items = []
                this.loading = false
                return Promise.resolve({data: {domains: []}})
            }

            return this.apiClientV2.get('/domains', {params: {kdnr: resolvedKdnr}}).then(({data}) => {
                this.items = data.domains || []
                return {data}
            }).finally(() => {
                this.loading = false
            })
        },
        show(id, kdnr = null) {
            this.contactLoading = true
            const resolvedKdnr = kdnr || useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr

            return this.apiClientV2.get(`/domains/${id}`, {params: {kdnr: resolvedKdnr}}).finally(() => {
                this.contactLoading = false
            })
        },
    },
})
